module.exports = __webpack_public_path__ + "static/media/cwiczenie_6.47540995.jpg";